import { CodeEditorAdapter, CodeEditorOptions, parseTableThemeInput } from "@reporting/rp-app-host";

/**
 * Raw JSON editor of the inline table theme (view_options.theme). The theme is
 * read through a callback - the editor works on the live working copy of the
 * table visualization editor.
 */
export class ThemeCodeEditorAdapter extends CodeEditorAdapter {

	constructor(
		private getTheme: () => Record<string, any>|null,
		private applyTheme: (theme: Record<string, any>) => void,
	) { super() }

	getContent(): string {
		const theme = this.getTheme();
		return theme ? JSON.stringify(theme, null, '\t') : '{}';
	}

	/**
	 * Parse and apply the theme, refresh the live preview. Returns false in
	 * every case: the change tracking runs through the edit event dispatched
	 * by the visualization editor, the save event of the code editor would
	 * mark the whole report as saved. A stored reference is refused with the
	 * rest of the non-themes - it would silently close the editing mode.
	 */
	save(content: string): boolean {
		const theme = parseTableThemeInput(content);
		if (theme) this.applyTheme(theme);
		return false;
	}

	getOptions(): CodeEditorOptions {
		return this.createOptions({
			language: 'json',
		});
	}

}
